import axios from "axios";
import { API_HOST } from "../../consts";

export const handlePostTopic = (payload) => (
	axios.post(`${API_HOST}/openai/topico`, payload)
		.then((response) => response)
		.catch((err) => console.log(err))
);

export const handlePostChapter = (payload) => (
	axios.post(`${API_HOST}/openai/capitulo`, payload)
		.then((response) => response.data)
		.catch((err) => console.log(err))
);

export const handlePostPageChapter = (payload) => (
	axios.post(`${API_HOST}/openai/pagina`, payload)
		.then((response) => response.data)
		.catch((err) => console.log(err))
);

export const handlePostBook = async (payload) => {
	const res = await axios.post(`${API_HOST}/openai/livro`, payload)
		.then((response) => response.data)
		.catch((err) => console.log(err))
	return res
}

export const handlePostSkill = async (payload) => {
	const res = await axios.post(`${API_HOST}/openai/habilidadecapitulo`, payload)
		.then((response) => response.data)
		.catch((err) => console.log(err))
	return res
}

export const handleReadBook = async (payload) => {
	const res = await axios.post(`${API_HOST}/openai/book_reader/main`, payload)
		.then((response) => response.data)
		.catch((err) => console.log(err))
	return res
}
